export const baseUrl = "https://farsight.supagrow.in";

export const getHome = "api/gethomepage";
export const getAbout = "api/getaboutpage"
export const getBlogs = "api/getblogs";
export const blogDetail = "api/blogdetails";
export const contactPage = "api/getcontactpage"

export const getEventCategory = "api/geteventscategory";
export const getEvents = "api/getevents";

export const getVendorPage = "api/getvendorpage";
export const getVendorCategory = "api/getvendorcategory";
export const getVendors = "api/getvendors";
export const vendorDetail = "api/vendordetails";

export const getSolutionPage = "api/getsolutionpage";
export const getServicePage = "api/getservicepage";

export const storeContact = "api/storecontactapi";
export const storePartner = "api/storepartnerapi";
export const emailSubscription = "api/storenewsletter";
